<template>
  <v-flex xs12 sm5 md5 class="bio">
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-right">
            <v-chip color="red" dark>Sonko Account</v-chip>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-avatar :size="avatarSize" color="grey lighten-4">
              <img src="https://vuetifyjs.com/apple-touch-icon-180x180.png" alt="avatar">
            </v-avatar>
            <h2>{{user.firstName}} {{user.lastName}}</h2>
            <hr/>
          </v-flex>

          <v-flex xs12>
            <p><v-icon>phone</v-icon> {{user.countryCode}}{{user.phone}}</p>
            <p><v-icon>mail</v-icon> {{user.email}}</p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "BioData",
  computed: {
    avatarSize() {
      return `156px`;
    },
    ...mapGetters(['user'])
  }
};
</script>


<style scoped>
.bio {
  font-size: 18px;
}

p {
  color: #808080;
}
</style>
